import { Vue } from 'vue-property-decorator';
import Form from '../../../form/form';
import userTransformer from '../../../transformers/user';

export default Vue.extend({
  inject: ['parentValidator'],
  props: {
    admins: {
      type: Array,
      default: () => [],
    },
    loadingAdmin: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      FormAdmin: new Form({
        data() {
          return {
            valid: false,
            user: null,
          };
        },
        transformToPayload: userTransformer.addAdmin,
      }),
      adminHeader: [
        { text: 'User Id', align: 'center', value: 'id', sortable: false },
        { text: 'Email', align: 'center', value: 'email', sortable: true },
        { text: 'Tel.', align: 'center', value: 'tel', sortable: true },
        { text: 'Role', align: 'center', value: 'roles', sortable: true },
      ],
    };
  },
  created() {
    // Share the parent's validator so v-validate directives feed the same validation pipeline.
    this.$validator = this.parentValidator;
  },
  methods: {
    onAddClick() {
      this.$validator.validateAll('FormAdmin').then((result) => {
        if (result) {
          this.$emit('add-admin', this.FormAdmin);
        }
      });
    },
    resetForm() {
      this.FormAdmin.user = null;
      this.FormAdmin.valid = false;
      this.$validator.reset('FormAdmin');
    },
  },
});
